import { Modal, Button } from "react-bootstrap";
import "./style.scss";
import DBModal from "../DBModal";
import DBButton from "../DBButton";
import { t } from "i18next";

export default function DBConfirmModal({
    show,
    onHide,
    btnTitle,
    onConfirm,
    title,
    description,
    loading,
    hideCancelBtn,
    minWidth,
    stacked,
}) {
    return (
        <DBModal
            show={!!show}
            onHide={onHide}
            permanent
            stacked={stacked}
            className="db-confirm-modal"
            minWidth={minWidth}
        >
            <DBModal.Content>
                <h4>{title}</h4>
                <p>{description}</p>
            </DBModal.Content>
            <DBModal.Footer>
                <div className="footer">
                    <DBButton
                        className="confirm-btn"
                        onClick={(e) => {
                            e.preventDefault();
                            onConfirm(e, show);
                        }}
                        caption={btnTitle}
                        loading={loading}
                    />
                    {!hideCancelBtn && (
                        <DBButton
                            className="cancel-btn"
                            onClick={(e) => {
                                e.preventDefault();
                                onHide(e);
                            }}
                            type="secondary"
                            caption={t("Organizational.Profile.Cancel")}
                        />
                    )}
                </div>
            </DBModal.Footer>
        </DBModal>
    );
}
